import React from 'react';
import { FadeIn } from './Shared';
import { XCircle } from 'lucide-react';
export const PainSection = () => {
  const pains = ['Llevás semanas durmiendo en fragmentos de 2 horas que nunca alcanzan', 'Tu bebé se duerme en brazos pero se despierta apenas toca la cuna', 'Probaste rutinas que funcionaron dos días y después dejaron de servir', 'No sabés si es hambre, dentición, regresión o simplemente un mal momento', 'El agotamiento ya está afectando tu trabajo, tu humor y tu pareja', 'Cada noche empezás de cero, sin saber qué va a pasar'];
  return <section className="py-8 md:py-12 px-4 bg-navy-900" data-id="element-176">
      <div className="max-w-3xl mx-auto" data-id="element-177">
        <FadeIn data-id="element-178">
          <h2 className="text-xl md:text-3xl font-serif font-bold text-white mb-5 text-center leading-tight" data-id="element-179">
            ¿Cuántas madrugadas más <br className="hidden md:block" data-id="element-180" />
            <span className="text-yellow-400 italic drop-shadow-[0_0_10px_rgba(250,204,21,0.2)]" data-id="element-181">
              vas a pasar así?
            </span>
          </h2>

          <div className="prose prose-invert mx-auto mb-6 text-gray-100 text-center text-sm md:text-base leading-relaxed px-2" data-id="element-182">
            <p className="mb-3" data-id="element-183">
              Son las 4 de la mañana. Tu bebé llora. Ya lo alimentaste, lo
              cambiaste, lo cargaste, lo meciste. Nada funciona. Mañana tenés
              que trabajar. Y lo único que encontrás en Google son métodos que
              se contradicen entre sí.
            </p>
            <p className="font-semibold text-white" data-id="element-184">
              No es falta de vocación. No es que tu bebé "es difícil". Es que
              nadie te dio un sistema claro.
            </p>
          </div>

          <div className="bg-navy-800/40 border border-navy-700/50 rounded-2xl p-5 md:p-8 mb-6 shadow-lg" data-id="element-185">
            <ul className="space-y-3 md:space-y-4" data-id="element-186">
              {pains.map((pain, index) => <li key={index} className="flex items-start" data-id="element-187">
                  <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(239,68,68,0.3)]" data-id="element-188" />
                  <span className="text-sm md:text-base text-white leading-snug" data-id="element-189">
                    {pain}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-190">
            <h3 className="text-lg md:text-2xl font-serif font-bold text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-191">
              ¿Y si esta fuera la última madrugada que pasás así?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
};